(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function fallbackCopy(text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    } catch (e) {}
  }
  function confirmCopy(btn, code) {
    btn.classList.add('is-copied');
    var live = btn.parentElement && btn.parentElement.querySelector('.cc-promo__live');
    if (live) { live.textContent = 'Code ' + code + ' copied'; }
    window.clearTimeout(btn._ccTimer);
    btn._ccTimer = window.setTimeout(function () {
      btn.classList.remove('is-copied');
      if (live) { live.textContent = ''; }
    }, 2200);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cc-promo__code');
    if (!btn) { return; }
    var code = btn.getAttribute('data-cc-code') || '';
    if (!code) { return; }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () { confirmCopy(btn, code); }).catch(function () {
        fallbackCopy(code); confirmCopy(btn, code);
      });
    } else {
      fallbackCopy(code); confirmCopy(btn, code);
    }
  });
  })();

/* CC-ANNBAR-CROSSFADE-2026-08-26 â€” hover-independent rotation */
(function () {
  function initRotate() {
    document.querySelectorAll('.announcement-bar-section .announcement-bar-slider .slider[data-cc-rotate="true"]').forEach(function (slider) {
      if (slider.__ccRotate) { return; }
      slider.__ccRotate = true;

      var slides = slider.querySelectorAll('.slider__slide');
      if (slides.length < 2) { return; }

      var speed = Math.max((parseFloat(slider.dataset.speed) || 5) * 1000, 2500);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var fadeOutMs = 180;
      var index = 0;
      var timer = null;
      var resizeTimer = null;
      var switching = false;

      function stepWidth() {
        return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : slider.clientWidth;
      }

      function currentIndex() {
        var step = stepWidth();
        return step > 0 ? Math.max(0, Math.min(slides.length - 1, Math.round(slider.scrollLeft / step))) : index;
      }

      function snapTo(next) {
        slider.scrollTo({ left: next * stepWidth(), behavior: 'auto' });
      }

      function stop() {
        if (timer) { window.clearTimeout(timer); timer = null; }
      }

      function schedule() {
        stop();
        timer = window.setTimeout(swap, speed);
      }

      function finishSwap(next) {
        snapTo(next);
        index = next;
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            slider.classList.remove('is-cc-switching');
            switching = false;
            schedule();
          });
        });
      }

      function swap() {
        if (switching) { return; }
        if (document.hidden) { schedule(); return; }

        index = currentIndex();
        var next = (index + 1) % slides.length;

        if (reduce) {
          snapTo(next);
          index = next;
          schedule();
          return;
        }

        switching = true;
        slider.classList.add('is-cc-switching');
        window.setTimeout(function () { finishSwap(next); }, fadeOutMs);
      }

      snapTo(0);
      schedule();

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); }
        else { schedule(); }
      });

      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () { snapTo(index); }, 120);
      });
    });
  }

  if (document.readyState !== 'loading') { initRotate(); }
  else { document.addEventListener('DOMContentLoaded', initRotate); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
